import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import MeetingsStatisticsAPI from '../../../api/MeetingsStatisticsAPI';

type Props = { timeRange: { start: string; end: string } };

function BookingsTotalPendingCard({ timeRange }: Props) {
  const { t } = useTranslation();
  const [total, setTotal] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await MeetingsStatisticsAPI.getBookingsTotal({ startTime: timeRange.start, endTime: timeRange.end });
        setTotal(res.data?.total || 0);
      } catch (e) {
        setTotal(0);
      }
    };
    fetchData();
  }, [timeRange.start, timeRange.end]);

  return (
    <div className="space-y-1">
      <p className="text-2xl font-bold text-foreground">{total}</p>
      <p className="text-sm text-muted-foreground">{t('stats.bookings_total_pending') || 'Pending bookings'}</p>
    </div>
  );
}

export default BookingsTotalPendingCard;


